import { PostCode } from "../constants/RegexConstants";

export default class PostCodeValidator {
  static isValidPostCode(postCode) {
    if (!PostCode.test(postCode)) {
      return false;
    }
    return true;
  }
}
